import { addDays } from 'date-fns/addDays';
import { isAfter } from 'date-fns/isAfter';

export const isNewProduct = (startOnSaleDate: Date, shouldShowNewBadge: boolean): boolean => {
  if (!startOnSaleDate || !shouldShowNewBadge) {
    return false;
  }
  return isWithinNewProductPeriod(startOnSaleDate);
};

export const isWithinNewProductPeriod = (startOnSaleDate: Date): boolean => {
  const endDateForNewProduct = addDays(startOnSaleDate, 7);
  const today = new Date();
  return isAfter(endDateForNewProduct, today);
};
